export default __webpack_public_path__ + "static/media/arrowExport.92fc6948.svg";